/**
 * The type of Stripe webhook event.
 *
 * `own` indicates that the event is from our own Stripe account.
 * `connected` indicates that the event is from a Stripe Connect account.
 */
export type StripeWebhookEventSource = 'own' | 'connected';
